export const RESERVED_SHOP_IDS = new Set([
  'auth',
  'login',
  'logout',
  'clientid',
  'api',
  '~',
  'socket.io',
  '__webpack_hmr'
])

// No shop id starts with _: such a first segment is a build path like /_nuxt/, and treating it
// as a shop made the server render fetch _nuxt's settings, vouchers and linked stores.
export function isReservedShopId (shopId: string | undefined | null): boolean {
  return !!shopId && (shopId.startsWith('_') || RESERVED_SHOP_IDS.has(shopId.toLowerCase()))
}
